var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "form-container" },
        [
          _c(
            "el-form",
            {
              ref: "subjectForm",
              staticClass: "subjectForm",
              attrs: {
                model: _vm.subjectForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "卡片名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.subjectForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.subjectForm, "name", $$v)
                      },
                      expression: "subjectForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "卡片标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片标题",
                      clearable: "",
                    },
                    model: {
                      value: _vm.subjectForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.subjectForm, "title", $$v)
                      },
                      expression: "subjectForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "卡片描述", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片描述",
                      clearable: "",
                    },
                    model: {
                      value: _vm.subjectForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.subjectForm, "description", $$v)
                      },
                      expression: "subjectForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片", prop: "coverImg" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        "before-upload": _vm.fileCheck,
                        "http-request": _vm.upload,
                        "show-file-list": false,
                      },
                    },
                    [
                      _vm.subjectForm.coverImg
                        ? _c("el-image", {
                            staticClass: "avatar",
                            attrs: {
                              src: _vm.subjectForm.coverImg,
                              fit: "scale-down",
                            },
                          })
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图片宽度尺寸" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.subjectForm.imgSelectWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.subjectForm, "imgSelectWidth", $$v)
                        },
                        expression: "subjectForm.imgSelectWidth",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "300" } }, [
                        _vm._v("小图：300px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: "700" } }, [
                        _vm._v("大图：700px (推荐)"),
                      ]),
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v("自定义图片宽度"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top",
                        width: "200",
                        trigger: "hover",
                        content:
                          "如果输入了自定义图片宽度，以自定义图片宽度为准",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-question",
                        staticStyle: {
                          "margin-left": "40px",
                          color: "#507dc5",
                        },
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm.subjectForm.imgSelectWidth === -1
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请输入图片宽度(单位px)",
                          clearable: "",
                        },
                        model: {
                          value: _vm.subjectForm.imgWidth,
                          callback: function ($$v) {
                            _vm.$set(_vm.subjectForm, "imgWidth", $$v)
                          },
                          expression: "subjectForm.imgWidth",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "内容列表", prop: "items" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.selectAppCards },
                    },
                    [_vm._v("选择")]
                  ),
                  _vm.subjectForm.items.length
                    ? _c(
                        "avue-crud",
                        {
                          ref: "crud",
                          staticStyle: { width: "100%" },
                          attrs: {
                            option: _vm.option,
                            data: _vm.subjectForm.items,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "coverImg",
                                fn: function ({ row }) {
                                  return [
                                    row.coverImg
                                      ? _c("el-image", {
                                          staticStyle: {
                                            width: "100px",
                                            height: "100px",
                                          },
                                          attrs: {
                                            src: row.coverImg,
                                            fit: "scale-down",
                                          },
                                        })
                                      : _c("span", [_vm._v("暂无图片")]),
                                  ]
                                },
                              },
                              {
                                key: "operation",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          disabled: !_vm.canMoveUp(
                                            _vm.subjectForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveUp(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              上移\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          disabled: !_vm.canMoveDown(
                                            _vm.subjectForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveDown(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              下移\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          disabled: !_vm.canMoveTop(
                                            _vm.subjectForm.items,
                                            row
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.moveTop(row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              置顶\n            "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#f56c6c" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove(row)
                                          },
                                        },
                                      },
                                      [_vm._v("移除")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1246536036
                          ),
                        },
                        [_c("template", { slot: "mySearch" })],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "9999",
                      "show-word-limit": "",
                      size: "small",
                      type: "textarea",
                      placeholder: "请输入备注",
                      clearable: "",
                    },
                    model: {
                      value: _vm.subjectForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.subjectForm, "remark", $$v)
                      },
                      expression: "subjectForm.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.subjectForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.subjectForm, "status", $$v)
                        },
                        expression: "subjectForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.subjectForm.status === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择", prop: "effectMode" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.subjectForm.effectMode,
                            callback: function ($$v) {
                              _vm.$set(_vm.subjectForm, "effectMode", $$v)
                            },
                            expression: "subjectForm.effectMode",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("立即生效"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("指定时间生效"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.subjectForm.status === 1 && _vm.subjectForm.effectMode === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "生效时间", prop: "effectTime" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "small",
                          "picker-options": {
                            disabledDate(time) {
                              return time.getTime() < Date.now() - 8.64e7
                            },
                          },
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "生效开始时间",
                          "end-placeholder": "生效结束时间",
                          clearable: "",
                        },
                        model: {
                          value: _vm.subjectForm.effectTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.subjectForm, "effectTime", $$v)
                          },
                          expression: "subjectForm.effectTime",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "btn-container",
          staticStyle: { "text-align": "right", "margin-top": "20px" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c("MultipleCards", {
        ref: "multipleCards",
        on: { save: _vm.getContentList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }